import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getNotificationTypes } from 'modules/settings/api';

export const useQueryGetNotificationTypes = () => {
  return useQuery(QUERY_KEYS.SETTINGS_NOTIFICATION_TYPES, getNotificationTypes, { cacheTime: 0 });
};
